/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, computed, signal} from '@angular/core';

import template from './signal-admin-resource-title.component.html';
import {LocalUserPermissions} from '../../../components/session/local-user-permissions';
import {objectTypeStateParams} from '../filters/object-type-state-params';
import {calculateCrumbs} from './crumb-calculator';
import {SignalAdminResourceModel} from './signal-admin-resource-api';
import {SignalAdminResourcePageState} from './signal-admin-resource-page-state';

interface SignalAdminResourceTitleCrumb {
  id?: string;
  name: string;
  obj: any;
  objectType: any;
  perm?: boolean;
  labelOverride?: string;
}

@Component({
  standalone: false,
  selector: 'adn-signal-admin-resource-title',
  template
})
export class SignalAdminResourceTitleComponent {
  private readonly pageState = signal<SignalAdminResourcePageState<SignalAdminResourceModel> | null>(null);

  @Input()
  set state(value: SignalAdminResourcePageState<SignalAdminResourceModel>) {
    this.pageState.set(value);
  }

  get state(): SignalAdminResourcePageState<SignalAdminResourceModel> {
    return this.pageState();
  }

  constructor(@Inject(LocalUserPermissions) private readonly localUserPermissions: any) {
  }

  readonly crumbs = computed<SignalAdminResourceTitleCrumb[]>(() => {
    const state = this.pageState();
    if (!state?.titleOptions?.crumbParams?.length) {
      return [];
    }
    const ctrl = {
      perms: this.localUserPermissions.getAllVisPermissions(),
      sectionPerms: this.localUserPermissions.getSectionPerms()
    };
    const crumbs: SignalAdminResourceTitleCrumb[] = [];
    state.titleOptions.crumbParams
      .filter((crumb) => !crumb.func || this.localUserPermissions[crumb.func]())
      .forEach((crumb) => calculateCrumbs(ctrl, crumb, state.model(), crumbs));
    return crumbs;
  });

  crumbStateParams(crumb: SignalAdminResourceTitleCrumb): Record<string, any> {
    return objectTypeStateParams(crumb.obj, crumb.objectType, crumb.obj);
  }
}
